import { isMac } from '../utils/isMac';
export const KEYBOARD_SHORTCUTS = [{
  altKey: false,
  ctrlKey: !isMac,
  metaKey: isMac,
  shiftKey: false,
  key: 'k',
  isGlobal: true
}, {
  altKey: false,
  ctrlKey: false,
  metaKey: false,
  shiftKey: false,
  key: 'ArrowUp',
  isGlobal: false
}, {
  altKey: false,
  ctrlKey: false,
  metaKey: false,
  shiftKey: false,
  key: 'ArrowDown',
  isGlobal: false
}, {
  altKey: false,
  ctrlKey: false,
  metaKey: false,
  shiftKey: true,
  key: 'ArrowUp',
  isGlobal: false
}, {
  altKey: false,
  ctrlKey: false,
  metaKey: false,
  shiftKey: true,
  key: 'ArrowDown',
  isGlobal: false
}, {
  altKey: false,
  ctrlKey: false,
  metaKey: false,
  shiftKey: false,
  key: 'Enter',
  isGlobal: false
}, {
  altKey: false,
  ctrlKey: !isMac,
  metaKey: isMac,
  shiftKey: false,
  key: 'ArrowLeft',
  isGlobal: false
}];